import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { consumeGiftHandoffFromUrl } from '../../utils/cartHandoff';
import { usePendingGiftClaim } from '../../hooks/usePendingGiftClaim';

/** Récupère le code cadeau du fragment d’URL, puis le réclame une fois connecté. */
export function GiftHandoffBootstrap() {
  const { hash } = useLocation();
  useEffect(() => {
    consumeGiftHandoffFromUrl();
  }, [hash]);
  usePendingGiftClaim();
  return null;
}
